import React from 'react';
import {Prose, Resource} from '~/library/types/src';
import {AwaitResource, cn} from '~/library/ui-kit';
import {useDashboardCategoryContext} from '../../../features/dashboard-asset-pages/ui/DashboardCategoryScreen';
import {DashboardCategoryTotal} from '../model/DashboardCategoryTotal';

export function DashboardCategoryShortLine({
    totals,
    width = 50,
}: {
    totals: Resource.Or<DashboardCategoryTotal>;
    width?: undefined | number;
}) {
    const {getKindName} = useDashboardCategoryContext();
    if (Resource.isResource(totals)) {
        return (
            <AwaitResource
                value={totals}
                render={totals => <DashboardCategoryShortLine totals={totals} />}
                skeleton={{width}}
            />
        );
    }
    const {count, balance} = totals;
    const amount = Prose.phrase([count, getKindName(count)]);
    return <DashboardDualDetailLine detail={[amount, balance]} />;
}

export function DashboardDualDetailLine({detail, center}: {detail: Prose | [Prose, Prose]; center?: boolean}) {
    const [main, extra] = [detail].flat();
    if (!extra) {
        return main;
    }
    return (
        <div className={cn('flex gap-2 whitespace-nowrap', center && 'justify-center')}>
            <span className='overflow-hidden text-ellipsis'>{main}</span>
            <span>{'|'}</span>
            <span className='shrink-0 overflow-hidden text-ellipsis'>{extra}</span>
        </div>
    );
}
